import React, { useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "../styles/ForgotPassword.css";
import logo from "../assets/logo1.png";
import 'bootstrap-icons/font/bootstrap-icons.css';
import Navbar from '../components/Navbar';

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ type: "", text: "" });
  const [emailSent, setEmailSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage({ type: "", text: "" });

    console.log('🔍 Frontend: Enviando solicitud de recuperación');
    console.log('📧 Email:', email);
    console.log('🌐 API URL:', `${process.env.REACT_APP_API_BASE_URL}/api/auth/forgot-password`);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/auth/forgot-password`,
        { email }
      );

      console.log('✅ Frontend: Respuesta recibida:', response.data);
      setMessage({ 
        type: "success", 
        text: response.data.message 
      });
      setEmailSent(true);
    } catch (error) {
      console.error('❌ Frontend: Error en la petición:', error);
      console.error('❌ Error response:', error.response?.data);
      setMessage({ 
        type: "error", 
        text: error.response?.data?.message || "Error al enviar el email" 
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Navbar />
      <div className="forgot-password-container">
        <div className="forgot-password-card">
          <div className="forgot-password-header">
            <img src={logo} alt="Logo" className="forgot-password-logo" />
            <h2>Recuperar Contraseña</h2>
            <p>Ingresa tu email y te enviaremos un enlace para restablecer tu contraseña</p>
          </div>

          {!emailSent ? (
            <form onSubmit={handleSubmit} className="forgot-password-form">
              <div className="form-group">
                <label htmlFor="email" className="form-label">
                  <i className="bi bi-envelope"></i> Email
                </label>
                <input
                  type="email"
                  id="email"
                  className="form-control"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="tu@email.com"
                  required
                  disabled={loading}
                />
              </div>

              {message.text && (
                <div className={`alert ${message.type === "success" ? "alert-success" : "alert-danger"}`}>
                  <i className={`bi ${message.type === "success" ? "bi-check-circle" : "bi-exclamation-triangle"}`}></i>
                  {message.text}
                </div>
              )}

              <button 
                type="submit" 
                className="btn btn-primary forgot-password-btn"
                disabled={loading}
              >
                {loading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    Enviando...
                  </>
                ) : (
                  <>
                    <i className="bi bi-send"></i> Enviar Enlace de Recuperación
                  </>
                )}
              </button>

              <div className="forgot-password-links">
                <Link to="/login" className="back-to-login">
                  <i className="bi bi-arrow-left"></i> Volver al Login
                </Link>
              </div>
            </form>
          ) : (
            <div className="email-sent-success">
              <div className="success-icon">
                <i className="bi bi-check-circle-fill"></i>
              </div>
              <h3>¡Email Enviado!</h3>
              <p>
                Hemos enviado un enlace de recuperación a <strong>{email}</strong>
              </p>
              <p className="instructions">
                Revisa tu bandeja de entrada y sigue las instrucciones para restablecer tu contraseña.
                El enlace expirará en 1 hora.
              </p>
              <div className="email-sent-actions">
                <Link to="/login" className="btn btn-primary">
                  <i className="bi bi-arrow-left"></i> Volver al Login
                </Link>
                <button 
                  onClick={() => {
                    setEmailSent(false);
                    setEmail("");
                    setMessage({ type: "", text: "" });
                  }}
                  className="btn btn-outline-secondary"
                >
                  <i className="bi bi-arrow-clockwise"></i> Intentar con otro email
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ForgotPassword;
